import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { PayButtonActive } from '../../actions/AccountingActions'
import { qpOpenModal } from "../../utils/misc";

class InvoiceSelection extends React.Component {
    state = {
        selectedInvoices: [],
        selectedAmount: 0,
        cards: this.props.cards
    }

    componentDidUpdate() {
        if (this.props.selectedInvoices !== this.state.selectedInvoices) {
            this.setState({
                selectedInvoices: this.props.selectedInvoices,
                selectedAmount: this.props.selectedAmount,
            });
        }
        if (this.props.cards !== this.state.cards) {
            this.setState({
                cards: this.props.cards
            });
        }
    }

    OpenPayModal = () => {

        this.props.PayButtonActive();
        qpOpenModal("#invoice-pay-modal")
    }

    render() {
        const { selectedInvoices } = this.state;
        const { cards } = this.state;

        return (
            <div className="d-flex align-items-center">
                <div className="d-flex">
                    <button
                        className={`btn btn-info icon-btn mr-2 ${!selectedInvoices.length ? 'disabled' : ''}`}
                        data-toggle="tooltip"
                        data-original-title="Export to Excel">
                        <FontAwesomeIcon icon={faFileExcel} size="lg" />
                        </button>
                    {cards.length > 0 && (
                    <button
                        className={`btn bg-green icon-btn mr-2 ${!selectedInvoices.length ? 'disabled' : ''}`}
                        data-toggle="tooltip"
                        data-original-title="Make payment"
                        onClick={this.OpenPayModal}>
                        <FontAwesomeIcon icon={faDollarSign} size="lg" />
                    </button>)}
                </div>
                <div className={`${this.state.selectedAmount ? 'd-flex' : 'd-none'} flex-column ml-4`}>
                    <p className="m-0 p-0 btn-group-title">Selected Amount:</p>
                    <p className="m-0 p-0 btn-group-detail" style={{ color: 'black' }}>${this.state.selectedAmount}</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedInvoices: state.accountingData.selectedInvoices,
        selectedAmount: state.accountingData.selectedAmount,
        cards: state.paymentData.cards,
    }
};


const mapDispatchToProps = dispatch => {
    return {
        PayButtonActive: () => dispatch(PayButtonActive())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceSelection);


// WEBPACK FOOTER //
// ./src/view/Accounting/InvoiceSelection.js